<template>
    <div class="
      h-[65px] min-h-[65px] text-[14px] font-caption

      lg:text-[16px] lg:h-[113px]

      w-full flex sticky bottom-0 font-bold
    ">
        <button
            class="bg-gray-200 h-full text-gray-darkest w-1/2 focus-outline-only-inside"
            @click="backToCustomizer"
        >
            {{ $t('BACK_TO_CUSTOMIZER') }}
        </button>
        <button
            class="bg-olive h-full text-white w-1/2 focus-outline-only-inside-white"
            @click="addToCart"
        >
            {{ $t('ADD_TO_CART') }}
        </button>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import {
        STEP_WALLET,
    } from '../constants';

    export default {
        mixins: [allStores],

        methods: {
            addToCart() {
                this.customizerStore.saveRecipe();
            },

            backToCustomizer() {
                this.appStore.setCurrentStep(STEP_WALLET);
            },
        },
    };
</script>
